import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Layout from '../../../components/Layout'
import { useParams, useSearchParams } from 'react-router-dom'
import PeriodeRpjmdSelector from '../../../components/PeriodeRpjmdSelector'
import { getDataIkd_newSakatoplan_act } from '../../../../redux/ducks/newsakatoplan/actions'
import BackButton from '../../../components/BackButton'

const NewDataIkd = ({ periodeState, dataIkdState, getDataIkd }) => {
    const [listYear, setListYear] = React.useState([])
    const { opdId, opdName, yearconfig } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [periodeData, setPeriodeData] = React.useState(null)

    const periode_id = searchParams.get('periode_id');
    const dataBreadcrumbs = [
        {
            title: 'Home',
            isActive: true,
            goTo: '/tahun/'+yearconfig,
          },
          {
            title: `Indikator Kinerja Daerah`,
            isActive: true,
            goTo: `/tahun/${yearconfig}/ikd/listopd`,
          },
    ]
    const [breadCrumbsData, setBreadCrumbsData] = React.useState();
    const [selectedPeriode, setSelectedPeriode] = React.useState();
    const onchangeperiode = (e) => {
        setSearchParams({ periode_id: e.target.value })
        setSelectedPeriode(e.target.value)
        let data = null
        
        periodeState.data.map((item) => { if(item.id == e.target.value){
            data = item;
            
        } } )

        setPeriodeData(data)
    }
    React.useEffect(() => {
        setBreadCrumbsData([...dataBreadcrumbs, {
            title: opdName,
            isActive: false,
            goTo: ''
        }])
    },[])
    React.useEffect(() => {
        if(periodeData){
            let asd = []
            for(let a = periodeData.awal; a<=periodeData.akhir; a++){
                asd.push(a)
            }
            setListYear(asd)
        }
        
    },[periodeData])
    React.useEffect(() => {
        if(periodeState.data.length > 0){
            let e = {
                target: {
                    value: 2
                }
            }
            onchangeperiode(e)
        }
    },[])
    const renderIndikator = (list) => {
        return list?.map((val, keys) => {
            return (
                <tr className='odd:bg-secondaryColor2' key={keys}>
                    <td className="border border-slate-500 p-2 text-center">{keys+1}</td>
                    <td className={`border border-slate-500 py-2 pr-2 ` + (val.tabs ? `pl-${(val.tabs*10)}` : `pl-2`) }>{val.nama_indikator}</td>
                    <td className="border border-slate-500 p-2 text-center">{val.satuan}</td>
                    {
                        listYear.map((item) => {
                            return (
                                <>
                                    <td className="border border-slate-500 p-2 text-center">{val[`t_${item}`]}</td>
                                    <td className="border border-slate-500 p-2 text-center">{val[`r_${item}`]}</td>
                                </>
                            )
                        })
                    }
                </tr>
            )
        })
    }
    React.useEffect(() => {
        getDataIkd(periode_id, opdId)
    },[])
    return (
        <Layout
            loading={dataIkdState.loading}
            breadCrumbsData={breadCrumbsData}
        >
            <div
                className="bg-white rounded-lg drop-shadow-2xl py-5 px-2 w-full"
            >
                <div className="flex-grow bg-white rounded-xl py-2 relative">
                    <h1 className="text-md text-primeColor1 text-center">Indikator Kinerja Daerah</h1>
                    <h1 className="mb-1 text-2xl font-bold text-center text-primeColor1">
                    {opdName}
                    </h1>
                    <hr className="mb-3" />
                </div>
                <div className="flow-grow bg-white rounded-xl py-2 relative flex justify-end items-end">
                    <div className="lg:w-1/3 md:w-1/2 w-full flex gap-2 flex-col">
                        <PeriodeRpjmdSelector selectedValue={selectedPeriode} onChangeAction={onchangeperiode} />
                    </div>
                </div>
                <div className="w-full flex flex-col justify-center sm:overflow-visible overflow-x-auto">
                    <table className="w-full table-auto text-xs mb-4">
                        <thead className="bg-primeColor1 text-white sticky top-0">
                            <tr>
                                <th className="border border-slate-500 md:w-[1%]" rowSpan={3}>
                                    No
                                </th>
                                <th className="border border-slate-500 md:w-1/4" rowSpan={3}>
                                    Indikator
                                </th>
                                <th className="border border-slate-500 md:w-1/12" rowSpan={3}>
                                    Satuan
                                </th>
                                <th className="border border-slate-500" colSpan={listYear.length * 2}>
                                    Tahun
                                </th>
                            </tr>
                            <tr>
                                {
                                    listYear.map((item) => {
                                        return (
                                            <th className="border border-slate-500" colSpan={2}>{item}</th>
                                        )
                                    })
                                }
                            </tr>
                            <tr>
                                {
                                    listYear.map((item) => {
                                        return (
                                            <>
                                                <th className="border border-slate-500">
                                                    <span className="md:block hidden">Target</span>
                                                    <span className="md:hidden block">T</span>
                                                </th>
                                                <th className="border border-slate-500">
                                                    <span className="md:block hidden">Realisasi</span>
                                                    <span className="md:hidden block">R</span>
                                                </th>
                                            </>
                                        )
                                    })
                                }
                            </tr>
                            
                        </thead>
                        <tbody>
                            {
                                dataIkdState.data ? dataIkdState.data.map((item, keys) => {
                                    const indikator = renderIndikator(item.indikator)
                                    const misi = (
                                        <>
                                            <tr key={keys}>
                                                <td className="border border-slate-500 py-2 px-5 bg-primeColor2 font-bold" colSpan="100%">{item.nama_urusan}</td>
                                            </tr>
                                            {
                                                indikator
                                            }
                                        </>
                                    )
                                    return (misi)
                                }) : 
                                <tr>
                                    <td className="border border-slate-500 py-2 px-5 bg-green-200" colSpan="100%">Loading...</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        <BackButton backLink={`/tahun/${yearconfig}/ikd/listopd`} />
        </Layout>
    )
}

const mapStateToProps = (state) => ({
    periodeState: state.newsakatoplanState.periodeRpjmd,
    dataIkdState: state.newsakatoplanState.dataIkd
})

const mapDispatchToProps = {
    getDataIkd: getDataIkd_newSakatoplan_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect, React.memo)(NewDataIkd)